const esLocale = {
	browserNotSupported: 'Parece que tu navegador no está soportado.',
	installOtherBrowser: 'Por favor instala alguna de estas opciones:',
	installNow: 'Instalar ahora',
};

export default esLocale;
